import { ImageScale } from '@front-app/services/ImageApi/ImageModel';
import { singleton } from '@front-app/util/interface';
import { getImageFetchers } from '@front-app/workers/ImageWorkerWrapper';
import { getEventsStore } from '../modules/events';
import { createV1ImageStore, createV2ImageStore } from '../modules/image';

export const EventsStore = singleton(getEventsStore);
export const EventsLogoStore = createV2ImageStore(() => getImageFetchers().getEventLogo, ImageScale.LARGE_2X);
export const EventsBannerStore = createV2ImageStore(() => getImageFetchers().getEventBanner, ImageScale.BANNER);
export const EventsVenueStore = createV2ImageStore(() => getImageFetchers().getEventVenue, ImageScale.VENUE);
export const getEventsVenueStoreV1 = createV1ImageStore;
export const PublicEventsBannerStore = createV2ImageStore(() => getImageFetchers().getPublicEventBanner, ImageScale.BANNER);
